export default {
    title: "Horario de Envío de Notificaciones",
    success_update: "Actualizado con éxito",
    copy_instruction:
        "Seleccione los días que recibirán la agenda copiada anteriormente",
    main_description:
        "Defina los horarios para el envío de notificaciones de acuerdo con los días de la semana, así como los horarios relativos al funcionamiento y/o atención del establecimiento",
    all: "Todos",
    copy: "Copiar",
    cancel: "Cancelar",
    save: "Guardar",
    success_copy: "¡Copiado con éxito!",
    error_save: "Error al intentar guardar los datos de programación.",
    success_paste: "¡Pegado con éxito!",
    browser_title: "Kevi | Horarios de Envío de Automatizaciones",
    unavailable: "No disponible",
    add: "Añadir",
    remove: "Eliminar",
    days: {
        sunday: "Domingo",
        monday: "Lunes",
        tuesday: "Martes",
        wednesday: "Miércoles",
        thursday: "Jueves",
        friday: "Viernes",
        saturday: "Sábado",
    },
};
